import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  Users,
  Package,
  Route,
  Car,
  MessageSquare,
  Settings,
  LogOut,
  Truck
} from 'lucide-react'
import { useAuth } from '../../hooks/useAuth'

const menuItems = [
  { 
    path: '/dashboard', 
    label: 'Dashboard', 
    icon: LayoutDashboard 
  },
  { 
    path: '/recipients', 
    label: 'Destinatários', 
    icon: Users 
  },
  { 
    path: '/deliveries', 
    label: 'Entregas', 
    icon: Package 
  },
  {
    path: '/routes',
    label: 'Rotas',
    icon: Route
  },
  {
    path: '/drivers',
    label: 'Motoristas',
    icon: Car
  },
  {
    path: '/feedback',
    label: 'Feedback',
    icon: MessageSquare
  },
]

export default function Sidebar({ isOpen, onClose }) {
  const { user, logout } = useAuth()

  return (
    <aside className={`
      fixed inset-y-0 left-0 z-40 h-screen w-64 bg-white border-r border-gray-200
      transform transition-transform duration-200 ease-in-out
      ${isOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0
    `}>
      <div className="flex flex-col h-full">
        {/* Logo */}
        <div className="flex items-center gap-2 px-6 py-5 border-b border-gray-200">
          <Truck className="w-8 h-8 text-primary-600" />
          <span className="text-xl font-bold text-gray-900">EntregaFácil</span>
        </div>

        {/* Menu */}
        <nav className="flex-1 px-4 py-6 space-y-1 overflow-y-auto">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={() => onClose?.()}
              className={({ isActive }) => `
                flex items-center gap-3 px-4 py-3 rounded-lg
                transition-colors duration-200
                ${isActive 
                  ? 'bg-primary-50 text-primary-700 font-medium' 
                  : 'text-gray-600 hover:bg-gray-100'
                }
              `}
            >
              <item.icon className="w-5 h-5" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Footer do Sidebar */}
        <div className="border-t border-gray-200 p-4">
          {/* Info do usuário */}
          <div className="flex items-center gap-3 px-4 py-3 mb-2">
            <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center">
              <span className="text-primary-700 font-medium">
                {user?.name?.charAt(0).toUpperCase() || 'U'}
              </span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">
                {user?.name || 'Usuário'}
              </p>
              <p className="text-xs text-gray-500 truncate">
                {user?.email}
              </p>
            </div>
          </div>

          {/* Botão de logout */}
          <button
            onClick={logout}
            className="flex items-center gap-3 w-full px-4 py-3 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <LogOut className="w-5 h-5" />
            Sair
          </button>
        </div>
      </div>
    </aside>
  )
}
